import { Box, Tooltip } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

import { EMPTY_CELL_VALUE } from 'utils/constants/constants';

interface OverflowTooltipCellProps {
  value?: string;
}

export const OverflowTooltipCell = ({ value }: OverflowTooltipCellProps) => {
  const cellRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const element = cellRef.current;
    if (!element) {
      return;
    }

    const checkOverflow = () =>
      setIsOverflowing(element.scrollWidth > element.clientWidth);

    checkOverflow();

    if (typeof ResizeObserver === 'undefined') {
      return;
    }

    const observer = new ResizeObserver(checkOverflow);
    observer.observe(element);

    return () => observer.disconnect();
  }, [value]);

  const displayValue = value || EMPTY_CELL_VALUE;

  return (
    <Tooltip title={isOverflowing ? displayValue : ''} placement="top">
      <Box
        ref={cellRef}
        sx={{
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          width: '100%'
        }}
      >
        {displayValue}
      </Box>
    </Tooltip>
  );
};
